import { Archive, FileText, Rows3, Puzzle, Image as ImageIcon, Images, SlidersHorizontal } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { ScrollArea } from "@/components/ui/scroll-area";
import PagesPanel from "./PagesPanel";
import SectionsPanel from "./SectionsPanel";
import ComponentsPanel from "./ComponentsPanel";
import AssetsPanel from "./AssetsPanel";
import SiteImagesPanel from "./SiteImagesPanel";
import ProjectPanel from "./ProjectPanel";
import ArchivePanel from "./ArchivePanel";
import { useEditor } from "./useEditorState";

const TABS = [
  { key: "pages", label: "Pagine", icon: FileText },
  { key: "sections", label: "Sezioni", icon: Rows3 },
  { key: "components", label: "Componenti", icon: Puzzle },
  { key: "images", label: "Immagini del sito", icon: Images },
  { key: "assets", label: "Asset", icon: ImageIcon },
  { key: "archive", label: "Archivio immagini", icon: Archive },
  { key: "project", label: "Impostazioni progetto", icon: SlidersHorizontal },
];

export default function LeftSidebar({ onCapture }) {
  const { ui, setUi } = useEditor();
  const Panel = { pages: PagesPanel, sections: SectionsPanel, components: ComponentsPanel, images: SiteImagesPanel, assets: AssetsPanel, archive: ArchivePanel, project: ProjectPanel }[ui.leftTab];
  return (
    <div className="h-full flex bg-white" data-testid="left-sidebar">
      <nav className="w-14 shrink-0 bg-navy-900 flex flex-col items-center gap-1 py-3">
        {TABS.map(({ key, label, icon: Icon }) => (
          <Tooltip key={key}>
            <TooltipTrigger asChild>
              <button onClick={() => setUi({ leftTab: key })} aria-label={label} data-testid={`left-tab-${key}`}
                className={`h-10 w-10 rounded-lg flex items-center justify-center transition-colors ${ui.leftTab === key ? "bg-navy-700 text-white" : "text-slate-400 hover:text-white hover:bg-navy-800"}`}>
                <Icon size={18} strokeWidth={1.8} />
              </button>
            </TooltipTrigger>
            <TooltipContent side="right">{label}</TooltipContent>
          </Tooltip>
        ))}
      </nav>
      <ScrollArea className="flex-1 min-w-0 border-r border-slate-200">
        <Panel onCapture={onCapture} />
      </ScrollArea>
    </div>
  );
}
